import { render, staticRenderFns } from "./UserDelete.vue?vue&type=template&id=bc376eb2&scoped=true&"
import script from "./UserDelete.vue?vue&type=script&lang=js&"
export * from "./UserDelete.vue?vue&type=script&lang=js&"
import style0 from "./UserDelete.vue?vue&type=style&index=0&id=bc376eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc376eb2",
  null
  
)

export default component.exports